<template lang="pug">
v-app
  em-menu
  v-content#content
    v-container
      .content-area
        .desciption
          h1.display-1 商品一覧
          p 商品情報の追加/編集/削除ができます
          .alert(v-show="cache != null")
            v-alert(:value='cache.result == true', type='success')
              | キャッシュの更新に成功しました。
            v-alert(:value='cache.result == false', type='error')
              | キャッシュの更新に失敗しました。
              br
              | {{ cache.message }}
        v-layout(wrap, align-center)
          v-flex(xs12, sm6, d-flex)
            v-select(:items='categories', v-model="category", item-text="category", item-value="id", label='カテゴリー', v-on:change="getItemList")
          v-spacer
          v-btn(color='primary', depressed, @click="openAddItemDialog") 新規追加
        v-data-table.elevation-1(:headers='headers', :items='data', :no-data-text="noDataText")
          template(v-slot:items='props')
            td {{ props.item.item_id }}
            td.text-xs {{ props.item.name }}
            td.text-xs
              img(:src="props.item.image_url", width="100px")
            td.text-xs {{ props.item.price + '円/' + props.item.unit }}
            td.text-xs(v-if="props.item.is_publish") 公開
            td.text-xs(v-else) 非公開
            td.text-xs
              v-flex(xs12, sm6, d-flex)
                v-btn(color='warning', depressed, small, @click="openEditItemDialog(props.item.item_id)") 詳細/編集
                v-dialog(v-model='props.item.publishDialog', persistent, max-width='290')
                  template(v-slot:activator='{ on }')
                    v-btn(v-if="props.item.is_publish", color='info', dark, small, v-on='on') 非公開にする
                    v-btn(v-else, color='green', dark, small, v-on='on') 公開する
                  v-card
                    v-card-title.headline 確認してください。
                    v-card-text(v-if="props.item.is_publish") 商品名: {{ props.item.name }}
                      br
                      | 本当に非公開にしてもよろしいですか。アプリに表示されなくなります。
                    v-card-text(v-else) 商品名: {{ props.item.name }}
                      br
                      | 本当に公開してもよろしいですか。アプリに表示されるようになります。
                    v-card-actions
                      v-spacer
                      v-btn(color='green darken-1', flat='', @click='props.item.publishDialog = false') Cancel
                      v-btn(v-if="props.item.is_publish", color='error darken-1', flat='', @click='turnPublishItem(props.index)') 非公開にする
                      v-btn(v-else, color='error darken-1', flat='', @click='turnPublishItem(props.index)') 公開する
                v-dialog(v-model='props.item.deleteDialog', persistent, max-width='290')
                  template(v-slot:activator='{ on }')
                    v-btn(color='error', dark, small, v-on='on') 削除
                  v-card
                    v-card-title.headline 確認してください。
                    v-card-text 商品名: {{ props.item.name }}
                      br
                      | 本当に削除してもよろしいですか。削除をすると、元に戻すことはできません。
                    v-card-actions
                      v-spacer
                      v-btn(color='green darken-1', flat='', @click='props.item.deleteDialog = false') Cancel
                      v-btn(color='error darken-1', flat='', @click='deleteItem(props.index)') Delete
        v-dialog(v-model='dialog', fullscreen, hide-overlay, transition='dialog-bottom-transition', scrollable)
          v-card(tile)
            v-toolbar(card, dark, color='primary')
              v-btn(icon, dark, @click='closeEditItemDialog')
                v-icon close
              v-toolbar-title(v-if="dialogMode == 'add'") 商品情報追加
              v-toolbar-title(v-else) 商品情報更新
              v-spacer
              v-toolbar-items
                v-btn(v-if="dialogMode == 'add'", dark, flat, @click='addItem') Save
                v-btn(v-else, dark, flat, @click='updateItem') Save
            v-card-text
              v-flex(xs4, style="padding-bottom: 20px")
                v-text-field(v-if="dialogMode == 'add'", label='商品ID*', required, v-model='item.itemId')
                h1.title(v-else) 商品ID: {{item.itemId}}
              v-flex(xs4)
                v-select(:items='categories', v-model="item.category", item-text="category", item-value="id", label='カテゴリー')
              v-flex(xs4)
                v-text-field(label='商品名*', required, v-model='item.name')
              v-layout(row, wrap)
                v-flex(xs2, v-for="imageUrl in item.imageUrls")
                  img(:src="imageUrl", width="200px")
              v-btn(@click="item.imageUrls.push('')", dark, small, color='primary') 画像を追加
              v-flex(xs5, v-for="(imageUrl, index) in item.imageUrls")
                v-layout(row)
                  v-text-field(label='画像URL*', required, v-model='item.imageUrls[index]')
                  v-btn(@click="item.imageUrls.splice(index, 1)", fab, dark, small, color='primary')
                    v-icon(dark) remove
              v-flex(xs3)
                v-layout(row)
                  v-flex(xs3)
                    v-text-field(label='価格*', required, v-model='item.price')
                  v-flex(xs4)
                    p(style="padding-top: 20px") 円 / {{item.unit}}
              v-flex(xs3)
                v-text-field(label='単位*', required='', v-model='item.unit')
              v-flex(xs6)
                v-textarea(name='input-7-1', label='詳細*', v-model='item.description', hint='商品の説明を記載してください')
              v-flex(xs8)
                v-layout(row, v-for="(detail, i) in item.details")
                  v-flex(xs5)
                    v-text-field(label='項目名', required='', v-model='detail.key')
                  v-flex(offset-xs1)
                  v-flex(xs5)
                    v-text-field(label='内容', required='', v-model='detail.value')
                  v-flex(xs1)
                    v-btn(@click="item.details.splice(i, 1)", fab, dark, small, color='primary')
                      v-icon(dark) remove
                v-btn(@click="item.details.push({key: '', value: ''})", dark, small, color='primary') １行追加
              v-flex(xs8)
                v-select(:items='producers', v-model="item.producer", item-text="name", item-value="id", label='生産者')
</template>
<script>
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'

export default {
  name: 'item',
  components: {
    EmMenu,
    API
  },
  data () {
    return {
      cache: {
        result: null,
        message: ''
      },
      dialog: false,
      dialogMode: '',
      categories: [],
      category: null,
      producers: [],
      item: {},
      headers: [
        {
          text: 'Item ID',
          align: 'left',
          value: 'itemId'
        },
        { text: 'name', value: 'name', sortable: false },
        { text: 'image', value: 'imageUrl', sortable: false },
        { text: '価格', value: 'price' },
        { text: '公開状況', value: 'isPublish', sortable: false },
        { text: '', sortable: false }
      ],
      data: [],
      noDataText: 'カテゴリーを選択してください'
    }
  },
  computed: {
  },
  methods: {
    // カテゴリーの一覧を取得する
    getCategoryList () {
      API.GetCategoryList().then(result => {
        this.categories = []
        result.categories.forEach((data, order) => {
          this.categories.push(data)
        })
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // 指定したカテゴリーの商品一覧を取得する
    getItemList () {
      API.GetItemList({ query: { category_id: this.category } }).then(result => {
        this.data = []
        result.items.forEach((data) => {
          data.deleteDialog = false
          data.publishDialog = false
          this.data.push(data)
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // 新規の商品を追加する
    addItem () {
      let errorDetails = []
      for (let i in this.item.details) {
        if (this.item.details[i].key === '' || this.item.details[i].key === undefined) {
          this.item.details.splice(i, 1)
        } else if (this.item.details[i].value === '' || this.item.details[i].value === undefined) {
          errorDetails.push(this.item.details[i].key)
        }
      }
      if (errorDetails.length > 0) {
        alert(errorDetails.join(',') + 'の項目で、「項目名」のみが入力されています。\n「内容」を入力してください。')
        return
      }
      // imageUrlsから空の要素を除去する
      this.item.imageUrls = this.item.imageUrls.filter(function (imageUrl) {
        return imageUrl !== ''
      })
      API.AddItem({ param: {
        item_id: this.item.itemId,
        name: this.item.name,
        image_url: JSON.stringify(this.item.imageUrls),
        category_id: this.item.category,
        price: this.item.price,
        unit: this.item.unit,
        description: this.item.description,
        detail_json: JSON.stringify(this.item.details),
        producer_id: this.item.producer
      } }).then(result => {
        if (result.message === 'ok') {
          this.dialog = false
          this.dialogMode = ''
          alert('商品情報を追加しました。')
          this.category = this.item.category
          this.updateCache()
          this.getItemList()
        }
      }).catch((err) => {
        console.log(err)
        alert('エラーが発生しました')
      })
    },
    // 商品情報を更新する
    updateItem () {
      let errorDetails = []
      for (let i in this.item.details) {
        if (this.item.details[i].key === '' || this.item.details[i].key === undefined) {
          this.item.details.splice(i, 1)
        } else if (this.item.details[i].value === '' || this.item.details[i].value === undefined) {
          errorDetails.push(this.item.details[i].key)
        }
      }
      if (errorDetails.length > 0) {
        alert(errorDetails.join(',') + 'の項目で、「項目名」のみが入力されています。\n「内容」を入力してください。')
        return
      }
      // imageUrlsから空の要素を除去する
      this.item.imageUrls = this.item.imageUrls.filter(function (imageUrl) {
        return imageUrl !== ''
      })
      API.UpdateItem({ param: {
        item_id: this.item.itemId,
        name: this.item.name,
        image_url: JSON.stringify(this.item.imageUrls),
        category_id: this.item.category,
        price: this.item.price,
        unit: this.item.unit,
        description: this.item.description,
        detail_json: JSON.stringify(this.item.details),
        producer_id: this.item.producer
      } }).then(result => {
        if (result.message === 'ok') {
          this.dialog = false
          this.dialogMode = ''
          alert('商品情報を更新しました。')
          this.updateCache()
          this.getItemList()
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    turnPublishItem (index) {
      let itemId = this.data[index].item_id
      API.TurnPublishItem({ param: { item_id: itemId } }).then(result => {
        if (result.message === 'ok') {
          this.data[index].publishDialog = false
          alert('公開設定の更新に成功しました')
          this.updateCache()
          this.data = []
          this.getItemList()
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // 商品を削除する
    deleteItem (index) {
      let itemId = this.data[index].item_id
      API.DeleteItem({ param: { item_id: itemId } }).then(result => {
        if (result.message === 'ok') {
          this.data[index].deleteDialog = false
          alert('商品を削除しました。')
          this.updateCache()
          this.data = []
          this.getItemList()
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // 新規商品追加用のダイアログを表示する
    openAddItemDialog () {
      // ダイアログを開く
      this.dialog = true
      this.dialogMode = 'add'
      // 最後に空の要素を追加する
      this.item = { details: [{ key: '', value: '' }], imageUrls: [''] }
    },
    // 商品情報を編集用のダイアログを表示する
    openEditItemDialog (itemId) {
      // ダイアログを開く
      this.dialog = true
      this.dialogMode = 'update'
      API.GetItemDetail({ pathParams: { item_id: itemId } }).then(result => {
        var category = this.categories.filter(x => x.id === result.category_id)[0]
        this.item = {
          itemId: result.item_id,
          category: category.id,
          name: result.name,
          imageUrls: JSON.parse(result.image_url),
          price: result.price,
          unit: result.unit,
          description: result.description,
          details: result.details,
          producer: result.producer.id
        }
        // 最後に空の要素を追加する
        this.item.details.push({ key: '', value: '' })
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // 商品情報編集用のダイアログを閉じる
    closeEditItemDialog () {
      // ダイアログを閉じる
      this.item = {}
      this.dialog = false
      this.dialogMode = ''
    },
    // 生産者一覧を取得する
    getProducerList () {
      API.GetProducerList().then(result => {
        this.data = []
        result.producers.forEach((data) => {
          this.producers.push(data)
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    updateCache () {
      API.UpdateCache().then(result => {
        if (result.message === 'ok') {
          // キャッシュ更新は成功
          this.cache = {
            result: true
          }
        } else if (result.message === 'error') {
          // キャッシュ更新は失敗
          this.cache = {
            result: false,
            message: result.error
          }
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    }
  },
  created () {
    this.getCategoryList() // category一覧取得
    this.getProducerList() // 生産者一覧取得
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

#content
  background-color #fff

</style>
